import { render, staticRenderFns } from "./Bera.vue?vue&type=template&id=03ff4671&scoped=true"
import script from "./Bera.vue?vue&type=script&lang=js"
export * from "./Bera.vue?vue&type=script&lang=js"
import style0 from "./Bera.vue?vue&type=style&index=0&id=03ff4671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ff4671",
  null
  
)

export default component.exports